/* Kingswood: the "Write a review" button under the review carousel (sections/kw-review-cta.liquid).
   The old Judge.me review widget (title, stars, histogram, list of reviews) is not shown on the page
   any more: its section is hidden at load, and the button opens a modal that holds ONLY Judge.me's
   review form. The whole widget element is moved into the modal (its event handlers travel with it,
   so the form submits, verifies and moderates through Judge.me exactly as before) and everything but
   the form wrapper is hidden by section-kw-review-cta.css. Judge.me only reveals its "Write a review"
   link once the widget is in view - it is, inside the open modal - and that link is clicked to open
   the form; if the link never shows, the form wrapper is forced open instead.
   A page without the widget follows the button's link (a product page with #write-a-review), where
   this script opens the modal after the page has loaded. */
(() => {
  const WAIT_MS = 5000;
  const widgetRoot = () => document.querySelector('.jdgm-widget.jdgm-review-widget');
  const writeLink = () => document.querySelector('.kw-review-modal .jdgm-write-rev-link');
  let modal;

  /* the legacy widget's own section stays out of sight */
  const hideWidgetSection = () => {
    const root = widgetRoot();
    const section = root && root.closest('.shopify-section');
    if (section) section.classList.add('kw-review-cta__hidden-widget');
  };

  const buildModal = () => {
    modal = document.createElement('div');
    modal.className = 'kw-review-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Write a review');
    modal.innerHTML =
      '<div class="kw-review-modal__backdrop" data-kw-close></div>' +
      '<div class="kw-review-modal__panel">' +
      '<button type="button" class="kw-review-modal__close" data-kw-close aria-label="Close">' +
      '<svg viewBox="0 0 18 17" aria-hidden="true" focusable="false"><path d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z" fill="currentColor"/></svg>' +
      '</button>' +
      '<div class="kw-review-modal__body"></div>' +
      '</div>';
    modal.addEventListener('click', (event) => {
      if (event.target.closest('[data-kw-close]')) close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
    document.body.appendChild(modal);
  };

  const open = () => {
    const root = widgetRoot();
    if (!root) return false;
    if (!modal) buildModal();
    const body = modal.querySelector('.kw-review-modal__body');
    if (root.parentElement !== body) body.appendChild(root);
    modal.classList.add('is-open');
    modal.classList.remove('kw-review-modal--forced');
    document.body.classList.add('kw-review-modal-open');
    modal.querySelector('.kw-review-modal__panel').scrollTop = 0;

    const started = Date.now();
    const tick = () => {
      const link = writeLink();
      if (link && link.style.display !== 'none') {
        /* "Cancel review" means the form is already open */
        if (!/cancel/i.test(link.textContent)) link.click();
        return;
      }
      if (Date.now() - started < WAIT_MS) setTimeout(tick, 200);
      else modal.classList.add('kw-review-modal--forced');
    };
    /* let Judge.me notice the widget is now in view */
    window.dispatchEvent(new Event('scroll'));
    window.dispatchEvent(new Event('resize'));
    setTimeout(tick, 150);
    return true;
  };

  const close = () => {
    modal.classList.remove('is-open');
    document.body.classList.remove('kw-review-modal-open');
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-kw-review-cta]');
    if (!button) return;
    if (widgetRoot()) {
      event.preventDefault();
      open();
    } else if (button.getAttribute('href') === '#') {
      event.preventDefault();
    }
  });

  hideWidgetSection();

  if (location.hash === '#write-a-review') {
    const start = () => {
      setTimeout(() => {
        let tries = 0;
        const whenWidgetExists = () => {
          if (widgetRoot()) open();
          else if (tries++ < 50) setTimeout(whenWidgetExists, 200);
        };
        whenWidgetExists();
      }, 400);
    };
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
  }
})();
